import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(public)/blog/quickmaths/SolvesChart.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.2.7_@babel+core@7.29.7_react-dom@19.2.7_react@19.2.7__react@19.2.7/node_modules/next/dist/client/app-dir/link.js");
